// Matches Firebase Auth error codes (e.g. 'auth/wrong-password'). This is a
// closed enum of kebab-case slugs, so logging the code never leaks free-form
// text or sensitive data.
const FIREBASE_AUTH_CODE = /^auth\/[a-z0-9-]+$/;

/**
 * Returns a safe, log-friendly identifier for an error.
 *
 * Only the Firebase Auth `code` (validated against a strict shape) is emitted.
 * Anything else collapses to 'unknown-error'. We never log `error.message`
 * (free-form text that may carry sensitive data) nor the full error object.
 *
 * @param {unknown} error
 * @returns {string} the auth error code, or 'unknown-error'
 */
export const getSafeErrorIdentifier = error =>
  typeof error?.code === 'string' && FIREBASE_AUTH_CODE.test(error.code)
    ? error.code
    : 'unknown-error';
